// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__HzOcB","item":"styles_item__P7MgE","icon":"styles_icon__u7t5z","value":"styles_value__xeyO9","label":"styles_label__Xq9MI"};